// eslint-disable-next-line @typescript-eslint/no-extraneous-class
export class Constantes {
	public static readonly PUESTO_OPE = "2";

	public static readonly UBICACION_PERDIDOS = "Z00Z00";

	public static readonly existenSubfamilias: boolean = true;

	public static readonly articulosDesubicados: boolean = false;

	public static readonly elegirComponentesOF: boolean = false;

	public static readonly existenCiclos: boolean = true;

	public static readonly existenFases: boolean = true;

	public static readonly existenLotes: boolean = false;
}


export const REGEX_ARTICULO = /^#?(?:(?:8422473(\d{5})\d)|(\d{5})) *$/u;
export const REGEX_CONTENEDOR = /^@(\d+)$/u;
export const REGEX_UBICACION = /^([A-Z]{1}\d{2}[A-Z]{1}\d{2})$/u;
export const REGEX_PUESTO = /^(P-\d{2})$/u;
export const REGEX_SUBPUESTO = /^(P-\d+-[A-Z]{1,2}) *$/u;